import React from "react";
import "../assets/Css/technologies.css";
import "../index.css"
import s1 from "../assets/images/shopify.svg";
import s2 from "../assets/images/webflow.svg";
import s3 from "../assets/images/wordpress.svg";
import s4 from "../assets/images/lareaval.svg";
import s5 from "../assets/images/nextjs.svg";
import s6 from "../assets/images/stripe.svg";
export default function Technologies() {
  return (
    <>
      <div className="technologies-wrapper ">
        <div className="technologies-container page-width">
          <div className="technologies-caption">
            <p>Techologies</p>
          </div>

          <div className="technologies-content">
            <div className="tech-cont-top">
              <div className="tech-cont1">
                <h1>
                  {" "}
                  We are using tools that are carefully selected and 
                  perfected{" "}
                </h1>
              </div>
              <div className="tech-cont2">
                <p>
                Using a vast array of web technologies that have been tried and tested in the real world, we create websites and web apps that run smoothly. Our methodology takes into account aspects like pricing, service, and scalability to make sure we discover the ideal solution for your project. Your success on the internet is the result of our strategic technology competence, not merely a goal in and of itself. 
                </p>
              </div>
            </div>
          </div>

          <div className="tech-cont-bottom">
            <div className="content-box">
              <div className="box">
                <img src={s1} alt="" />
              </div>
              <div className="box">
                <img src={s2} alt="" />
              </div>
              <div className="box">
                <img src={s3} alt="" />
              </div>
              <div className="box">
                <img src={s4} alt="" />
              </div>
              <div className="box">
                <img src={s5} alt="" />
              </div>
              <div className="box">
                <img src={s6} alt="" />
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
